export function normalizeAxiosError(error, fallback = "Une erreur est survenue") {
  if (!error) return fallback;

  const responseData = error.response?.data;
  if (responseData) {
    if (typeof responseData === "string") {
      return responseData;
    }

    if (typeof responseData === "object") {
      if (responseData.detail) {
        return responseData.detail;
      }

      if (responseData.message) {
        return responseData.message;
      }

      const firstEntry = Object.values(responseData)[0];
      if (Array.isArray(firstEntry)) {
        return firstEntry[0] ?? fallback;
      }

      if (typeof firstEntry === "string") {
        return firstEntry;
      }
    }
  }

  if (error.message) {
    return error.message;
  }

  return fallback;
}

export default normalizeAxiosError;
